export const SET_ACTIVE_USER_ID = "SET_ACTIVE_USER_ID";
export const SET_TYPING_VALUE = "SET_TYPING_VALUE";
export const SEND_MESSAGE = "SEND_MESSAGE";


// WEBPACK FOOTER //
// ./src/constants/action-types.js